module.exports = __webpack_public_path__ + "static/media/meditating-messagers.163695cb.png";